// load brace
import ace from 'brace'

// load required ace plugins
import 'brace/mode/json'
import 'brace/ext/searchbox'

export default ace



/** WEBPACK FOOTER **
 ** ./src/assets/ace/index.js
 **/